import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import { Trans, withTranslated } from "components";

const MODAL_ID = 'employee-add-success';

const AddEmployeeInfo = ({ close, t }) => (
    <ReduxModal
      id={MODAL_ID}
    >
      {(Modal) => (
        <div>
          <Modal.Heading title={t("Pracownik został dodany")} subtitle={t("Może się teraz zalogować")} />
          <Modal.Footer>
            <button type="button" onClick={close} className="full-btn has-margin-left"><Trans>Ok, rozumiem</Trans></button>
          </Modal.Footer>
        </div>
      )}
    </ReduxModal>
  );

AddEmployeeInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default withTranslated(AddEmployeeInfo);


// WEBPACK FOOTER //
// ./src/components/globalModals/AddEmployeeInfo.jsx